module.exports = __webpack_public_path__ + "static/media/mobile-app.87c70903.svg";